import React from 'react';

interface GridInfoProps {
  data: any[];
  gridStyle?: any;
}

const GridInfo = ({
  data,
  gridStyle = {},
}: GridInfoProps) => (
  <div
    style={{
      alignItems: 'start',
      display: 'flex',
      justifyContent: 'space-evenly',
    }}
  >
    {data.map((datum, datumIndex) => (
      <div
        key={datumIndex}
        style={{
          display: 'grid',
          flex: 1,
          gridTemplateColumns: '1fr 1fr',
          ...gridStyle,
        }}
      >
        {datum.map((subDatum: any, subDatumIndex: number) => (
          <React.Fragment key={subDatumIndex}>
            <div style={{ fontWeight: 'bold' }}>
              {subDatum.label}&nbsp;{`:`}
            </div>
            <div>
              {subDatum.value}
            </div>
          </React.Fragment>
        ))}
      </div>
    ))}
  </div>
);

export default GridInfo;
